import React, {useEffect, useState} from 'react'
import {useParams, Link} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import './index.css'

const courseDetailsApiBase = 'https://apis.ccbp.in/te/courses'

const CourseItemDetails = () => {
  const {id} = useParams()
  const [details, setDetails] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)

  const fetchDetails = async () => {
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await fetch(`${courseDetailsApiBase}/${id}`)
      if (response.ok) {
        const data = await response.json()
        // alias the API's snake_case to a camelCase variable
        const {course_details: courseDetails} = data
        const formatted = {
          id: courseDetails.id,
          name: courseDetails.name,
          imageUrl: courseDetails.image_url,
          description: courseDetails.description,
        }
        setDetails(formatted)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        setIsError(true)
      }
    } catch (e) {
      setIsLoading(false)
      setIsError(true)
    }
  }

  useEffect(() => {
    fetchDetails()
    // eslint-disable-next-line
  }, [id])

  let content = null

  if (isLoading) {
    content = (
      <div data-testid="loader" className="loader-container">
        <Loader type="TailSpin" color="#4656a1" height={50} width={50} />
      </div>
    )
  } else if (isError) {
    content = (
      <main className="failure-main">
        <img
          src="https://assets.ccbp.in/frontend/react-js/tech-era/failure-img.png"
          alt="failure view"
          className="failure-image"
        />
        <h1>Oops! Something Went Wrong</h1>
        <p>We cannot seem to find the page you are looking for</p>
        <button type="button" className="retry-button" onClick={fetchDetails}>
          Retry
        </button>
      </main>
    )
  } else if (details) {
    content = (
      <main className="details-content">
        <img
          src={details.imageUrl}
          alt={details.name}
          className="course-hero"
        />
        <h1>{details.name}</h1>
        <p>{details.description}</p>
      </main>
    )
  }

  return (
    <div className="details-page">
      <header className="details-header">
        <Link to="/">
          <img
            src="https://assets.ccbp.in/frontend/react-js/tech-era/website-logo-img.png"
            className="logo"
            alt="website logo"
          />
        </Link>
      </header>

      {content}
    </div>
  )
}

export default CourseItemDetails
